import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=190fbeba&scoped=true&external"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"
import style0 from "./Request.vue?vue&type=style&index=0&id=190fbeba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fbeba",
  null
  
)

export default component.exports